export type DestinationReelProvider = 'youtube' | 'instagram';

export type ParsedDestinationReelUrl = {
  provider: DestinationReelProvider;
  id: string;
  url: string;
};

const YOUTUBE_SHORTS_RE =
  /^https?:\/\/((www|m)\.)?youtube\.com\/shorts\/([A-Za-z0-9_-]{6,})\/?(?:[?#].*)?$/i;

const INSTAGRAM_REEL_RE =
  /^https?:\/\/(www\.)?instagram\.com\/reels?\/([A-Za-z0-9_-]+)\/?(?:[?#].*)?$/i;

/** Parse a stored reel URL into provider + embed id. Returns null when unsupported. */
export function parseDestinationReelUrl(raw: string): ParsedDestinationReelUrl | null {
  const url = raw.trim();
  const yt = YOUTUBE_SHORTS_RE.exec(url);
  if (yt) {
    return { provider: 'youtube', id: yt[3]!, url };
  }
  const ig = INSTAGRAM_REEL_RE.exec(url);
  if (ig) {
    return { provider: 'instagram', id: ig[2]!, url };
  }
  return null;
}

export function destinationReelEmbedSrc(parsed: ParsedDestinationReelUrl): string {
  if (parsed.provider === 'youtube') {
    return `https://www.youtube.com/embed/${parsed.id}`;
  }
  return `https://www.instagram.com/reel/${parsed.id}/embed`;
}

/** Static thumbnail URL when available (YouTube). Instagram needs oEmbed server-side. */
export function destinationReelThumbnailSrc(parsed: ParsedDestinationReelUrl): string | null {
  if (parsed.provider === 'youtube') {
    return `https://img.youtube.com/vi/${parsed.id}/hqdefault.jpg`;
  }
  return null;
}

export function isDestinationReelUrl(raw: string): boolean {
  return parseDestinationReelUrl(raw) !== null;
}
